const STORAGE_KEY = 'staleBuildReloadAt'
const RETRY_WINDOW_MS = 30000
const STALE_BUILD_ERROR = /Loading (CSS )?chunk [\w-]+ failed|ChunkLoadError|Failed to fetch dynamically imported module|Unexpected token '<'/

const isStaleBuildError = error => STALE_BUILD_ERROR.test(String(error?.message || error || ''))

const reloadOnce = () => {
  try {
    const last = Number(sessionStorage.getItem(STORAGE_KEY) || 0)
    if (Date.now() - last < RETRY_WINDOW_MS) return
    sessionStorage.setItem(STORAGE_KEY, String(Date.now()))
  } catch (error) {
    return
  }
  window.location.reload()
}

export default function reloadOnStaleBuild(router) {
  router.onError(error => {
    if (isStaleBuildError(error)) reloadOnce()
  })
  window.addEventListener('error', event => {
    if (isStaleBuildError(event.error || event.message)) reloadOnce()
  })
  window.addEventListener('unhandledrejection', event => {
    if (isStaleBuildError(event.reason)) reloadOnce()
  })
}
